import { render, staticRenderFns } from "./GenericUpdateRole.vue?vue&type=template&id=815d4cbe&scoped=true"
import script from "./GenericUpdateRole.vue?vue&type=script&lang=js"
export * from "./GenericUpdateRole.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=815d4cbe&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815d4cbe",
  null
  
)

export default component.exports